<template>
  <painel-component :items="itemsOne">
    <error-component :errors="errors" v-if="showError" />

    <form v-if="viewPage">
      <row-component>
        <col-component
          class-col="col-xxl-9 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.client_id }"
        >
          <label>Cliente:</label>
          <div class="input-container">
            <input-component v-model="selectedClientName" placeholder="Cliente" disabled />
            <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
          </div>
        </col-component>

        <col-component
          class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.entry_date }"
        >
          <label>Data entrada:</label>
          <input-component v-mask="'##/##/####'" v-model="formData.entry_date" placeholder="00/00/0000" />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.bank }"
        >
          <label>Banco:</label>
          <MultiSelect v-model="formData.bank" placeholder="Banco" :options="selectBankList" />
        </col-component>

        <col-component
          class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.agency }"
        >
          <label>Agência:</label>
          <input-component v-model="formData.agency" />
        </col-component>

        <col-component
          class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.digit_account }"
        >
          <label>Conta/Dígito:</label>
          <input-component v-model="formData.digit_account" />
        </col-component>

        <col-component
          class-col="col-xxl-2 col-xl-2 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.value }"
        >
          <label>Valor:</label>
          <input-component v-model="formData.value" v-money="MONEY" />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.issuer_name }"
        >
          <label>Nome do emitente:</label>
          <input-component v-model="formData.issuer_name" />
        </col-component>

        <col-component
          class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.number }"
        >
          <label>N° cheque:</label>
          <input-component v-model="formData.number" />
        </col-component>

        <col-component
          class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.due_date }"
        >
          <label>Data vencimento:</label>
          <input-component v-mask="'##/##/####'" v-model="formData.due_date" placeholder="00/00/0000" />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.email }"
        >
          <label>Email:</label>
          <input-component v-model="formData.email" />
        </col-component>

        <col-component
          class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.phone }"
        >
          <label>Telefone:</label>
          <input-component v-mask="['(##) ####-####', '(##) #####-####']" v-model="formData.phone" />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.description }"
        >
          <label>Descrição:</label>
          <text-area v-model="formData.description" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-route class="w-100" :items="itemsTwo" />
        </col-component>

        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-submit :disabled="sendForm" @click="submit" class="w-100" icon="plus" name="Adicionar" />
        </col-component>
      </row-component>
    </form>

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import TextArea from '@/components/form/TextArea';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ErrorComponent from '@/components/alerts/ErrorComponent';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';

import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { mask } from 'vue-the-mask';
import { useToast } from 'vue-toastification';

const toast = useToast();
export default {
  name: 'CheckManagementCreate',

  components: {
    ErrorComponent,
    ButtonRoute,
    ButtonSubmit,
    TextArea,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent,
    OrderPartClientSearch
  },

  directives: {
    money: VMoney,
    mask
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Controle de Cheques');
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Adicionar',
        icon: 'pen square'
      },

      itemsTwo: {
        route: '/check-management/search',
        icon: 'reply all',
        name: 'Voltar'
      },

      formData: {
        client_id: '',
        bank: '',
        agency: '',
        digit_account: '',
        entry_date: '',
        number: '',
        issuer_name: '',
        phone: '',
        email: '',
        value: '0,00',
        due_date: '',
        description: ''
      },

      MONEY,
      selectedClientName: '',
      openModalClient: false,
      errors: [],
      viewPage: false,
      sendForm: false,
      showError: false
    };
  },

  methods: {
    submit() {
      if (!this.sendForm) {
        this.sendForm = true;
        this.$store
          .dispatch('storeCheckManagement', this.formData)
          .then(r => {
            this.showError = false;
            this.sendForm = false;
            this.errors = [];
            toast.success('Cadastro efetuado com sucesso', { timeout: 1500 });
            this.$router.push({ name: 'check-management-edit', params: { id: r } });
          })
          .catch(e => {
            this.showError = true;
            this.sendForm = false;
            window.scroll(0, 0);
            this.errors = e.response?.data?.errors || [];
          });
      }
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.formData.issuer_name = this.formData.issuer_name || client.name || '';
      this.openModalClient = false;

      this.$store
        .dispatch('loadClient', client.id)
        .then(data => {
          if (!this.formData.phone && data.phones?.length) {
            const phone = data.phones[0];
            this.formData.phone = `${phone.area || ''}${phone.number || ''}`;
          }
          if (!this.formData.email && data.emails?.length) {
            this.formData.email = data.emails[0].address || data.emails[0].email || '';
          }
        })
        .catch(() => {});
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 26)
        .then(r => {
          if (r.indexOf('check-management-create') !== -1) {
            this.viewPage = true;
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    }
  },

  computed: {
    selectBankList() {
      return this.$store.state.var.selectBankList;
    }
  }
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}
</style>
